<template>
  <div class="coursecontainer">
    <!-- 菜单导航 -->
    <Menu></Menu>
    <!-- 教程内页 -->
    <div class="courseDetail">
      <div class="breadcrumb_box">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/tool' }">资源库</el-breadcrumb-item>
          <el-breadcrumb-item>{{ detail.name }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="course-body">
        <div class="left">
          <div class="lan-des opensdet-intro-des clearfix">
            <div class="title">
              <h1 class="opensdet-intro-title ">{{ detail.name }}</h1>
            </div>
            <div class="details-tags"><a href="javascript:void(0);">sai</a> <a href="javascript:void(0);">快捷键</a> <a
                href="javascript:void(0);">软件</a> <a href="javascript:void(0);">基础</a></div>
            <div class="introduction">{{ detail.introduction }}</div>
            <div class="content">
              <p v-html=" detail.content "></p>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="mulu">
            <p class="mu_title">　下载地址</p>
            <div class="menu-list">
              <p>本站所有软件均来源于网络
                仅供学习使用，请支持正版</p>
              <a :href="detail.url" target="_balank"><el-button class="dowload" type="info">下载地址</el-button></a>
            </div>
          </div>
          <div class="mulu pass" v-if="detail.password">
            下载密码：<b>{{ detail.password }}</b>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部链接 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import Menu from '@/components/view/Menu'
  import Footer from '@/components/view/Footer'
  export default {
    name: 'home',
    components: {
      Menu,
      Footer
    },
    data() {
      return {
        detail: {

        },
        tuijData: []
      }
    },
    created() {
      this.userInfo = JSON.parse(this.$cookieStore.getCookie('userInfo'))
      this.getInfo()
    },
    methods: {
      getInfo() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/tool/detail', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          },
          data: {
            id: this.$route.query.id
          }
        }).then(res => {
          this.detail = res.data.data
          this.$axios({
            method: 'post', // 请求格式
            url: '/api/course/RecommendCourse', // 请求路径
            headers: { // 设置请求头
              token: this.$cookieStore.getCookie('token')
            },
            data: {
              "limit": 8,
              "page": 1
            }
          }).then(res => {
            let data = res.data.data.data
            this.tuijData = data
          }).catch(err => {
            console.log(err)
          })
        }).catch(err => {})
      }
    },
  }
</script>

<style lang="scss" scoped>
  .introduction {
    padding: 30px 40px;
    background: #f0f4f5;
    margin: 30px 10px 10px 0;
    border-radius: 6px;
    font-size: 14px;
    line-height: 25px;
  }

  .course_content_box {
    overflow: hidden;
  }

  /deep/.course_content_box img {
    max-width: 850px !important;
    width: 100% !important;
  }

  .content {
    width: 850px;
    margin: 30px 0 10px 0;

  }

  /deep/ .content img {
    max-width: 850px !important;
  }

  // 右侧
  .pass {
    font-size: 16px;
    margin-top: 20px;
  }

  .pass b {
    font-size: 22px;
    color: #FAC007
  }

  .courseDetail {
    .course-body {
      .right {
        .title_thumb_box {
          background-color: rgb(246, 248, 250);
          padding: 20px 10px;
          border-radius: 14px;
          margin-bottom: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .guanzu {
            width: 60px;
            height: 28px;
            background: #D4EAFC;
            border-radius: 14px;
            font-size: 12px;
            color: #027CDB;
            text-align: center;
            line-height: 28px;
            border: none;
            cursor: pointer;
          }
        }

        .mulu {
          background-color: rgb(246, 248, 250);
          padding: 20px 10px;
          border-radius: 14px;
          text-align: center;

          p {
            width: 70%;
            margin: 20px auto;
          }

          .dowload {
            width: 80%;
            margin: 10px 0;
            background: black;
          }

          .dowload a {
            color: white;
          }

          .mu_title {
            font-size: 18px;
            color: #212B34;
            font-weight: 500;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /deep/ .video-js .vjs-big-play-button {
    top: 45%;
    left: 45%;
  }

  .opensdet-intro-des {
    border-bottom: 1px solid #F1F3F5;
    border-radius: 1px;
  }

  .opensdet-intro-des {
    padding-bottom: 25px;
  }

  .lan-des {
    position: relative;
    display: table-cell;
    width: 864px;
    text-align: left;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .opensdet-intro-des .title {
    padding: 20px 0 0 0;
  }

  .opensdet-intro-des .opensdet-intro-title {
    margin: unset;
    color: #212B34;
    font-weight: 500;
    vertical-align: middle;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 25px;
  }



  .vcourse-detail-share .left {
    display: inline-block;
    padding-right: 20px;
  }

  .details-tags {
    white-space: normal;
    color: #B1B5B9;
  }

  .details-tags {
    min-height: 24px;
    margin: 10px 0;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: black;
  }

  .details-tags>a:first-child {
    margin-left: 0;
  }

  .details-tags a {
    margin-right: 10px;
    height: 25px;
    line-height: 25px;
    background-color: #F6F8FA;
    border-radius: 6px;
    text-align: center;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
    padding: 0 10px;
    color: black;
  }

  .courseDetail {
    padding: 0px;
    margin: 0px;
    width: 1200px;
    margin: 0 auto;
  }

  .course-details-wrap_width {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0 0 30px 0;
  }

  .course-right_area {
    margin-left: 15px;
    box-sizing: border-box;
    width: 335px;
    background-color: #fff;
    border-radius: 8px;

  }

  .course-left_area {
    width: 850px;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 8px;
    padding: 20px 0px 18px 0px;
    margin-bottom: 0px;
  }

  .course-recommendation_wrap {
    padding: 0;
    margin: 0;
  }

  .course-list {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    cursor: pointer;
  }

  .list_right {
    flex: 1;
    display: flex;
    flex-direction: column;
    text-align: left;
    justify-content: space-between;
  }

  .study_num {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #a3a8ab;
  }

  .right__top {
    margin: 0;
  }

  .right__top .title {
    width: 144px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-bottom: 10px;
    color: #18252c;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
  }

  .label-tit {
    position: relative;
    text-align: left;
    padding-left: 16px;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #18252c;
  }

  .label-line {
    width: 6px;
    height: 18px;
    background-color: #FABE00;
  }

  .the-tabs {
    border: 0;
  }

  .description {
    margin-top: 25px;
  }

  .description img {
    display: block;
  }

  .heads {
    display: flex;
  }

  .course-details-wrap_width .course-left_area .the-tabs .heads li {
    min-width: 72px;
    height: 25px;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 600;
    color: #747c80;
    line-height: 25px;
    cursor: pointer;
    z-index: 10;
    text-align: center;
  }

  .active {
    font-weight: 600;
    color: #18252c !important;
    border-bottom: 4px solid #00d753;
  }

  .content_top {
    padding: 40px 0 10px 0;
  }

  .course-body {
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    border-radius: 8px;
    padding-bottom: 50px;
    padding-left: 0;
    position: relative;
  }

  .course-body .left {
    width: 850px;
    margin-right: 20px;
  }

  .course-body .left .course-banner {
    width: 850px !important;
    height: 500px !important;
  }

  .course-body .right {
    flex: 1;
    box-sizing: border-box;
  }

  .wrap__bottom .price-tag {
    font-size: 18px;
  }

  .wrap__bottom .course-handle {
    width: 295px;
    height: 56px;
    font-size: 19px;
    line-height: 56px;
    text-align: center;
    background: linear-gradient(270deg, #ff4d40, #ff7e75);
    border-radius: 8px;
    cursor: pointer;
  }

  .wrap__bottom .course-handle span {
    font-size: 19px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #fff;
    line-height: 26px;
  }

  .course-body .right .course-info_wra .course-data {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #747c80;
    line-height: 6px;
    padding: 14px 0 24px 0;
  }

  .course-body .right .course-info_wrap .wrap__top h3 {
    height: 45px;
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #18252c;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 600px;
    text-align: left;
  }

  .course-body .right .course-desc {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #747c80;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 6;
  }

  .course-body .right .course-data {
    text-align: left;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #747c80;
    line-height: 6px;
    padding: 14px 0 24px 0;
  }

  .dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #d1d3d5;
    vertical-align: top;
    margin: 0 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ToolDetail.vue